import { render } from "./SignUpComplete.vue?vue&type=template&id=0c535a89&scoped=true&ts=true"
import script from "./SignUpComplete.vue?vue&type=script&lang=ts"
export * from "./SignUpComplete.vue?vue&type=script&lang=ts"

import "./SignUpComplete.vue?vue&type=style&index=0&id=0c535a89&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c535a89"]])

export default __exports__